'use client'

import { useState } from 'react'
import header from '../components/header'
import OrderEntry from './OrderEntry'
import DispatchEntry from './DispatchEntry'
import Admin from './Admin'
import Report from './Report'
import Header from '../components/header'

export default function Dashboard() {
  const [isOrderEntryOpen, setIsOrderEntryOpen] = useState(false)
  const [isDispatchEntryOpen, setIsDispatchEntryOpen] = useState(false)
  const [currentSection, setCurrentSection] = useState(null)

  const handleOpenOrderEntry = () => {
    setIsOrderEntryOpen(true)
    setCurrentSection(null)
  }

  const handleCloseOrderEntry = () => {
    setIsOrderEntryOpen(false)
  }

  const handleOpenDispatchEntry = () => {
    setIsDispatchEntryOpen(true)
    setCurrentSection(null)
  }

  const handleCloseDispatchEntry = () => {
    setIsDispatchEntryOpen(false)
  }

  const handleNavigate = (section) => {
    setCurrentSection(section)
    setIsOrderEntryOpen(false)
    setIsDispatchEntryOpen(false)
  }

  const renderCurrentSection = () => {
    switch (currentSection) {
      case 'admin':
        return <Admin />
      case 'report':
        return <Report />
      default:
        return null
    }
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <Header />
      {/* <Header 
        onOpenOrderEntry={handleOpenOrderEntry}
        onOpenDispatchEntry={handleOpenDispatchEntry}
        onNavigate={handleNavigate}
      /> */}
      
      <main className="container mx-auto px-4 py-8">
        {renderCurrentSection()}
        
        {/* <OrderEntry 
          isOpen={isOrderEntryOpen} 
          onClose={handleCloseOrderEntry} 
        />

        <DispatchEntry 
          isOpen={isDispatchEntryOpen} 
          onClose={handleCloseDispatchEntry} 
        /> */}
      </main>
    </div>
  )
}

